import { IStyleConfig, mergeStyles } from '@cian/components';
import * as React from 'react';

const style = require('./index.css');

export interface IRow {
  title: React.ReactNode;
  headStyles?: IStyleConfig;
}

export interface IInlineElement {
  children?: React.ReactNode;
  customStyles?: IStyleConfig;
}

export const Row: React.StatelessComponent<IRow> = ({ title, children, headStyles }) => (
  <div className={style['row']}>
    <div {...mergeStyles(style['cellHead'], headStyles)}>{title}</div>
    <div className={style['cellContent']}>{children}</div>
  </div>
);

export const InlineParam: React.StatelessComponent<IInlineElement> = ({ children, customStyles }) => (
  <div {...mergeStyles(style['inlineParam'], customStyles)}>{children}</div>
);

export const InlineBlock: React.StatelessComponent<IInlineElement> = ({ children, customStyles }) => (
  <div {...mergeStyles(style['inlineBlock'], customStyles)}>{children}</div>
);

export const InlineLabel: React.StatelessComponent<IInlineElement> = ({ children }) => (
  <div className={style['inlineLabel']}>{children}</div>
);

export const ColumnsContainer: React.StatelessComponent<IInlineElement> = ({ children }) => (
  <div className={style['columnsContainer']}>{children}</div>
);

export const Column: React.StatelessComponent<IInlineElement> = ({ children }) => (
  <div className={style['column']}>{children}</div>
);
